<template>
  <div>
    <!-- <a class="contact-us" title="联系我们" target="_blank" href="/contactus">
      <span class="icofont-comment" style="line-height: inherit;"></span>
    </a> -->
    <div class="scroll-to-top" @click="GoTop()"><span class="icofont-rounded-up" style="line-height: inherit;"></span></div>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue